import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { formatNumMil } from "../../../components/utils/format";

const ProjectCard = ({ project, onViewDetails, onRequestQuote }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat("es-GT", {
      style: "currency",
      currency: "GTQ",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })?.format(amount);
  };

  return (
    <div className="bg-white rounded-xl solar-shadow-card overflow-hidden solar-hover-lift">
      {/* Project Image */}
      <div className="relative h-48 overflow-hidden">
        <Image
          src={project?.image}
          alt={project?.title}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-4 left-4">
          <span
            className={`px-3 py-1 rounded-full text-xs font-medium ${project?.tipo === "Residencial"
              ? "bg-blue-100 text-blue-800"
              : project?.tipo === "Comercial"
                ? "bg-green-100 text-green-800"
                : "bg-amber-100 text-amber-800"
              }`}
          >
            {project?.tipo}
          </span>
        </div>
        <div className="absolute top-4 right-4">
          <div className="bg-white/90 backdrop-blur-sm px-2 py-1 rounded-lg">
            <span className="text-xs font-semibold text-primary">
              {formatNumMil(project?.generaDiaria * 1000, 1)}Wh/día
            </span>
          </div>
        </div>
      </div>
      {/* Project Content */}
      <div className="p-6">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 className="text-lg font-semibold text-foreground mb-1">
              {project?.nombreProyecto}
            </h3>
            <div className="flex items-center text-sm text-muted-foreground">
              <Icon name="MapPin" size={14} className="mr-1" />
              {project?.ubicacion}
            </div>
          </div>
          <div className="text-right">
            <div className="text-sm text-muted-foreground">Generación Mensual</div>
            <div className="text-lg font-bold text-success">
              {formatNumMil(project?.generaMensual * 1000, 0)}Wh
            </div>
          </div>
        </div>

        {/* Key Metrics */}
        <div className="grid grid-cols-2 gap-4 mb-4">
          <div className="text-center p-3 bg-muted/50 rounded-lg">
            <div className="text-sm text-muted-foreground">Paneles</div>
            <div className="text-lg font-semibold text-foreground">
              {project?.totalPaneles}
            </div>
          </div>
          <div className="text-center p-3 bg-muted/50 rounded-lg">
            <div className="text-sm text-muted-foreground">
              Energía Anual
            </div>
            <div className="text-lg font-semibold text-foreground">
              {formatNumMil(project?.generaAnual * 1000, 2)}Wh
            </div>
          </div>
        </div>

        {/* Customer Rating & Comment */}
        <div className="space-y-2 mb-4">
          <div className="flex items-center">
            <div className="flex items-center mr-3">
              {[...Array(5)]?.map((_, i) => (
                <Icon
                  key={i}
                  name="Star"
                  size={16}
                  className={`${i < project?.calificacion
                    ? "text-amber-400 fill-current"
                    : "text-gray-300"
                    }`}
                />
              ))}
            </div>
          </div>
          {project?.comentario && (
            <p className="text-sm text-muted-foreground italic">
              "{project?.comentario}"
            </p>
          )}
        </div>

        {/* Action Buttons */}
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            iconName="Eye"
            iconPosition="left"
            onClick={() => onViewDetails(project)}
            className="flex-1"
          >
            Ver Detalles
          </Button>
        </div>
        <div className="flex gap-2">
          <Button
            variant="default"
            size="sm"
            iconName="Calculator"
            iconPosition="left"
            onClick={() => onRequestQuote(project)}
            className="flex-1 bg-cta-orange hover:bg-cta-orange/90"
          >
            Cotizar Similar
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
